import { Button, Form, Image, Input, message, Modal, Select, Tooltip,Upload  } from "antd";
import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { useSelector } from "react-redux";
import countries from "../../../components/countries.json";
import ImagePicker from "../../../components/imagePicker";
import API from "../../../config/api";
import { COMPRESS_IMAGE, POST, PUT, UPLOAD_FILE } from "../../../utils/apiCalls";
import { InboxOutlined, FilePdfOutlined, FilePptOutlined, FileWordOutlined, FileTextOutlined, FileUnknownOutlined } from "@ant-design/icons";
function Forms(props: any) {
  const [form] = Form.useForm();
  const Events = useSelector((state: any) => state.Events);
  const [loading, setLoading] = useState(false);
  const [image_url, setImageUrl] = useState<any>(props?.data?.logo);
  const [file, setFile] = useState<any>();
  const [docUrl, setDocUrl] = useState<string | null>(props?.data?.docs);
  const [docSize, setDocSize] = useState<number | null>(null);
  const [tempSelectedName, setTempSelectedName] = useState<string | null>(null);
  const [tempSelectedSize, setTempSelectedSize] = useState<number | null>(null);
  const getFileIconByName = (filename: string | undefined | null) => {
    const name = (filename || "").toLowerCase();
    const ext = name.split(".").pop() || "";
    if (ext === "pdf") return <FilePdfOutlined style={{ color: "#cf1322", fontSize: 20 }} />;
    if (ext === "ppt" || ext === "pptx") return <FilePptOutlined style={{ color: "#d46b08", fontSize: 20 }} />;
    if (ext === "doc" || ext === "docx") return <FileWordOutlined style={{ color: "#1677ff", fontSize: 20 }} />;
    if (ext === "txt") return <FileTextOutlined style={{ color: "#595959", fontSize: 20 }} />;
    return <FileUnknownOutlined style={{ fontSize: 20 }} />;
  };
  const getNameFromUrl = (url: string) => {
    try {
      const last = (new URL(url).pathname || "").split("/").filter(Boolean).pop();
      return last ? decodeURIComponent(last) : "document";
    } catch {
      const parts = (url || "").split("/");
      return parts.pop() || "document";
    }
  };
  const [docName, setDocName] = useState<string | null>(
    props?.data?.docs ? getNameFromUrl(props?.data?.docs) : null
  );

  const formatBytes = (bytes: number) => {
    if (bytes === 0) return "0 B";
    const k = 1024;
    const sizes = ["B", "KB", "MB", "GB", "TB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const value = parseFloat((bytes / Math.pow(k, i)).toFixed(2));
    return `${value} ${sizes[i]}`;
  };

  const cascaderOptions = countries?.map((country) => ({
    flag: country?.flag,
    value: country?.dial_code,
    label: `${country.dial_code}`,
  }));
  const onFinish = async (values: any) => {
    try {
      setLoading(true);
      let url = props?.data?.id ? API.STARTUPS_EDIT : API.STARTUPS_ADD;
      let images: any = await COMPRESS_IMAGE(file);
      let obj = {
        id: props?.data?.id,
        name: values.name,
        category: values.category,
        logo: file?.name ? images?.url : image_url,
        description: values.description,
        founder: values.founder,
        country: values.country,
        Stage: values.Stage,
        fund_raised: values.fund_raised,
        notable_inverstors: values.notable_inverstors,
        members: values?.members,
        eventId: Events?.defult?.id,
        countrycode: values?.countrycode || '+971',
        email: values?.email,
        phone: values?.phone,
        docs: docUrl || null,
      };
      const METHORD = props?.data?.id ? PUT : POST
      let response: any = await METHORD(url, obj);
      if (response.status) {
        props.onChange();
        props.onClose();
        message.success("Successfully submitted");
      } else {
        message.error(response.message);
      }
      setLoading(false);
    } catch (err) {
      console.log("err", err);
      message.error("Oops.something gone wrong.");
      setLoading(false);
    }
  };

  return (
    <Modal
      title={`${props?.data?._id ? "Edit" : "New"} Startups`}
      open={props.visible}
      onCancel={() => props.onClose()}
      footer={false}
      maskClosable={false}
      centered
      closable={!loading}
      width={800}
    >
      <Form
        form={form}
        onFinish={onFinish}
        scrollToFirstError
        initialValues={{
          id: props?.data?.id,
          name: props?.data?.name,
          category: props?.data?.category,
          logo: props?.data?.logo,
          description: props?.data?.description,
          founder: props?.data?.founder,
          country: props?.data?.country,
          Stage: props?.data?.Stage,
          fund_raised: props?.data?.fund_raised,
          notable_inverstors: props?.data?.notable_inverstors,
          members: props?.data?.members,
          countrycode: props?.data?.countrycode || '+971',
          email: props?.data?.email,
          phone: props?.data?.phone,
        }}
      >
        <Row>
          <Col sm={6}>
            <div className="label">Startup Name *</div>
            <Form.Item
              name={"name"}
              rules={[{ required: true, message: "Please enter startup name" }]}
            >
              <Input
                placeholder="Startup Name"
                size="large"
                type="text"
                
              />
            </Form.Item>
            <div className="label">Phone Number *</div>
            <Form.Item
              name={"phone"}
              rules={[
                // {
                //   required: true,
                //   message: "Please enter phone number",
                // },
                {
                  pattern:
                    /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/,
                  message: "Enter a valid phone number",
                },
              ]}
            >
              <Input
                type="tel"
                style={{ width: "100%" }}
                placeholder="Phone number"
                onKeyPress={(event) => {
                  if (!/^[0-9]+$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                addonBefore={
                  <Form.Item
                    noStyle
                    name="countrycode"
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: "",
                    //   },
                    // ]}
                  >
                    <Select
                      placeholder=""
                      style={{ width: 100 }}
                      showSearch
                      dropdownStyle={{ width: 100 }}
                      allowClear
                    >
                      {cascaderOptions?.map(
                        (item: any, index: number) => {
                          return (
                            <Select.Option
                              key={index}
                              value={item?.value}
                            >
                              <div className="d-flex align-items-center gap-2">
                                <Image
                                  width={31}
                                  alt={item?.code}
                                  preview={false}
                                  src={`https://flagsapi.com/${item?.flag}/flat/24.png`}
                                />
                                {item?.label}
                              </div>
                            </Select.Option>
                          );
                        }
                      )}
                    </Select>
                  </Form.Item>
                }
                size="large"
              />
            </Form.Item>

            <div className="label">Founder *</div>
            <Form.Item
              name={"founder"}
              rules={[{ required: true, message: "Please enter founder" }]}
            >
              <Input
                placeholder="Founder"
                size="large"
                type="text"
                onKeyPress={(event) => {
                  if (!/^[a-zA-Z ]+$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
            </Form.Item>
            <div className="label">Headquarters</div>
            <Form.Item
              name={"country"}
            >
              <Input
                placeholder="Headquarters"
                size="large"
                type="text"
                onKeyPress={(event) => {
                  if (!/^[a-zA-Z ]+$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
            </Form.Item>
            <div className="label">Sector *</div>
            <Form.Item
              name={"category"}
             
            >
              <Input
                placeholder="Sector"
                size="large"
                type="text"
                onKeyPress={(event) => {
                  if (!/^[a-zA-Z ]+$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
            </Form.Item>


            <div className="label">Description *</div>
            <Form.Item
              name={"description"}
              rules={[
                {
                  max: 1000,
                  message: "Description cannot exceed 1000 characters",
                },
              ]}
            >
              <Input.TextArea
                rows={4}
                maxLength={1000}
                placeholder="Description"
                size="large"
              />
            </Form.Item>
          </Col>
          <Col sm={6}>
            <div className="label">Investment Stage *</div>
            <Form.Item
              name={"Stage"}
                     >
              <Input
                placeholder="Investment Stage"
                size="large"
                type="text"
                onKeyPress={(event) => {
                  if (!/^[a-zA-Z ]+$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
            </Form.Item>
            <div className="label">Email *</div>
            <Form.Item
              name={"email"}
              rules={[
               
                { type: "email", message: "Enter a valid email" },
              ]}
            >
              <Input
                placeholder="Email"
                size="large"
                type="email"

              />
            </Form.Item>
            <div className="label">Fund Raised *</div>
            <Form.Item
              name={"fund_raised"}
            >
              <Input
                placeholder="Fund Raised"
                size="large"
                type="text"
                onKeyPress={(event) => {
                  if (!/^[a-zA-Z0-9,.₹£$€¥₩₽₪₹₦د.إDH]$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
            </Form.Item>
            <div className="label">Team Members</div>
            <Form.Item
              name={"members"}
             
            >
              <Input placeholder="Team Members" size="large" type="text" />
            </Form.Item>

            <div className="label d-flex justify-content-between">
              Startup Logo
              {image_url ? (
                <Tooltip placement="top" title={"Remove logo"}>
                  <IoIosCloseCircleOutline
                    color="red"
                    size={20}
                    onClick={() => {
                      setImageUrl(null);
                      setFile(null);
                    }}
                  />
                </Tooltip>
              ) : null}
            </div>

            <Form.Item
              name={"logo"}

            >
              <ImagePicker

                onChange={(value: any) => {

                  setImageUrl(value?.url);
                  setFile(value?.file);
                }}
                fileURL={image_url}
                formats={["image/png", "image/jpeg", "image/jpg"]}
              />
            </Form.Item>
            <div className="label">Notable Investors</div>
            <Form.Item
              name={"notable_inverstors"}
              
            >
              <Input.TextArea
                rows={4}
                placeholder="Notable Inverstors"
                size="large"
              />
            </Form.Item>
          </Col>
        </Row>
        <Col md={6}>
            <div className="label d-flex justify-content-between">
                Startup Deck
              {docUrl ? (
                <Tooltip placement="top" title={"Remove document"}>
                  <IoIosCloseCircleOutline
                    color="red"
                    size={20}
                    onClick={() => {
                      setDocUrl(null);
                      setDocName(null);
                    }}
                  />
                </Tooltip>
              ) : null}
            </div>
            <Form.Item name={"docs"}>
              {docUrl ? (
                <Upload
                  listType="text"
                  fileList={[{ uid: "-1", name: `${docName || "document"}`, status: "done", url: docUrl, size: docSize ?? undefined }]}
                  itemRender={(originNode, file) => {
                    const sizeToShow = (file as any)?.size ?? docSize ?? null;
                    return (
                      <div>
                        {originNode}
                        {sizeToShow != null ? (
                          <div style={{ fontSize: 12, color: "#8c8c8c", marginLeft: 24 }}>
                            {formatBytes(sizeToShow)}
                          </div>
                        ) : null}
                      </div>
                    );
                  }}
                  iconRender={(file) => getFileIconByName(file.name)}
                  onPreview={(file) => {
                    if (file.url) {
                      window.open(file.url as string, "_blank");
                    }
                  }}
                  onRemove={() => {
                    setDocUrl(null);
                    setDocName(null);
                    setDocSize(null);
                    return true;
                  }}
                  showUploadList={{ showRemoveIcon: true, showPreviewIcon: true, showDownloadIcon: false }}
                />
              ) : (
                <Upload.Dragger
                  name="file"
                  multiple={false}
                  maxCount={1}
                  accept={[
                    "application/pdf",
                    "application/msword",
                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                    "application/vnd.ms-powerpoint",
                    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
                    "text/plain",
                  ].join(",")}
                  beforeUpload={async (file) => {
                    try {
                      setTempSelectedName(file.name);
                      setTempSelectedSize(file.size);
                      const MAX_SIZE = 20 * 1024 * 1024; // 20MB
                      if (file.size > MAX_SIZE) {
                        message.error("File is too large. Maximum size is 20MB.");
                        setTempSelectedName(null);
                        setTempSelectedSize(null);
                        return Upload.LIST_IGNORE;
                      }
                      const res: any = await UPLOAD_FILE(file);
                      if (res?.status && res?.url) {
                        setDocUrl(res.url);
                        setDocName(file.name);
                        setDocSize(file.size);
                        setTempSelectedName(null);
                        setTempSelectedSize(null);
                        message.success(`${file.name} uploaded`);
                      } else {
                        message.error("File upload failed");
                        setTempSelectedName(null);
                        setTempSelectedSize(null);
                      }
                    } catch {
                      message.error("Failed to upload file");
                      setTempSelectedName(null);
                      setTempSelectedSize(null);
                    }
                    return Upload.LIST_IGNORE;
                  }}
                >
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">Click or drag file to this area to upload</p>
                  <p className="ant-upload-hint">
                    Supports PDF, DOC, DOCX, PPT, PPTX, TXT. Max 1 file. Up to 20MB.
                  </p>
                </Upload.Dragger>
              )}
              {!docUrl && tempSelectedName && tempSelectedSize != null ? (
                <div style={{ fontSize: 12, color: "#8c8c8c", marginTop: 8 }}>
                  {tempSelectedName} — {formatBytes(tempSelectedSize)}
                </div>
              ) : null}
            </Form.Item></Col>
        <Row>
          <Col sm={6}></Col>
          <Col sm={6}>
            <Row>
              <Col sm={6}>
                <Button block size="large" onClick={() => props.onClose()} disabled={loading}>
                  Close
                </Button>
              </Col>
              <Col sm={6}>
                <Button
                  htmlType="submit"
                  block
                  size="large"
                  type="primary"
                  loading={loading}
                  disabled={loading}
                >
                  Done
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

export default Forms;
